import { render, staticRenderFns } from "./accountSettingPortal.vue?vue&type=template&id=57760f6c&scoped=true&"
import script from "./accountSettingPortal.vue?vue&type=script&lang=js&"
export * from "./accountSettingPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57760f6c",
  null
  
)

export default component.exports